import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { baseTimeRecordsActions, baseTimeRecordsSelectors, BaseCoreState } from '../../../_store';
import { BaseInquiryBestCandidatesPayloadInterface } from '../../inquiry/_interfaces/base-inquiry-best-candidates-payload.interface';

@Injectable()
export class BaseTimeRecordsListGuard {
  constructor(private readonly store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(
      baseTimeRecordsActions.loadTimeRecordsList({
        payload: route.queryParams as BaseInquiryBestCandidatesPayloadInterface,
      })
    );

    return this.store.select(baseTimeRecordsSelectors.getTimeRecordsList).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
